import { Action, ActionReducer, createReducer, MetaReducer, on } from '@ngrx/store';

import { ErrorType } from '@shared/models/ErrorTypes';
import { AuthActions, SiteContextActions } from '@spartacus/core';
import { produce } from 'immer';
import { ReturnOverviewRequest, ReturnOverviewResponse } from '../../model/return-history.model';
import { ReturnOverviewActions } from '../actions';

export const RETURN_OVERVIEW_FEATURE_KEY = 'returnOverview';

export interface ReturnOverviewState {
  request: ReturnOverviewRequest;
  response: ReturnOverviewResponse;
  loading: boolean;
  error: ErrorType;
}

export const initialState: ReturnOverviewState = {
  request: undefined,
  response: undefined,
  loading: false,
  error: undefined
};

export const returnOverviewReducer = createReducer(
  initialState,

  on(ReturnOverviewActions.loadReturnOverview, (state, action) => ({
    ...state,
    loading: true,
    request: action.request,
    response: undefined
  })),
  on(ReturnOverviewActions.loadReturnOverviewSuccess, (state, action) => ({
    ...state,
    loading: false,
    response: action.response,
    request: undefined
  })),
  on(ReturnOverviewActions.loadReturnOverviewFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.errorResponse
  }))
);

function authenticationOrLanguageChangedOverview(action: Action, state): any {
  if (action.type === AuthActions.LOGIN ||
    action.type === AuthActions.LOGOUT ||
    action.type === SiteContextActions.LANGUAGE_CHANGE
  ) {
    const nextState = produce(state, (draftState) => {
      draftState.returnHistory.returnOverview = initialState;
    });
    return nextState;
  }
  return state;
}

export function metaReducerFactoryReturnOverview(): MetaReducer<any> {
  return (reducer: ActionReducer<any>) => (state, action) => {
    const newState = authenticationOrLanguageChangedOverview(action, state);
    return reducer(newState, action);
  };
}
